import React from 'react'
import { JUKE_PATH_A } from '@constant'

export default [
  {
    title: '申请时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '提交内容',
    dataIndex: 'content',
    key: 'content',
    width: 400
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <div style={{ textAlign: 'center' }}>
        {(status == 0 || status == 3) && <p>审核中</p>}
        {status == 1 && (
          <div style={{ color: '#80d089' }}>
            <p>审核通过</p>
            <p>（即将上线）</p>
          </div>
        )}
        {status == 2 && <p style={{ color: '#ff705e' }}>审核不通过</p>}
      </div>
    )
  },
  {
    title: '操作',
    key: 'id',
    render: ({ id }) => <a href={`${JUKE_PATH_A}/view/${id}`}>查看详情</a>
  }
]
